module.exports = __webpack_public_path__ + "img/4.6e0e378a.webp";